import React from 'react'

import {
  Tab
} from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'

import Documents from './components/Documents'

const ConsultaDocumentosComponent: React.FC = () => {
  const {
    tabs,
    handleChangeTab,
    selectedTab
  } = useTabs(['Pesquisar'])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab.position} handleChange={handleChangeTab} />
      {selectedTab.position === 0 && <Documents />}
    </>
  )
}

const ConsultaDocumentos: React.FC = () => {
  return (
    <TabsProvider>
      <ConsultaDocumentosComponent />
    </TabsProvider>
  )
}

export default ConsultaDocumentos
